const update = color => {
  const $restockText = document.querySelector(".js-pdp-restock-date-text");
  if (!$restockText) return;

  const $priceRows = document.querySelectorAll(".js-product-details-quantity-form-row-item");
  const sumOos = Array.from($priceRows)
    .filter(elem => elem.dataset.activeColor === color)
    .reduce((sum, elem) => sum + parseInt(elem.attributes["oos-count"]?.value || 0, 10), 0);

  if (sumOos > 0) {
    $restockText.classList.add("has-oos");
  } else {
    $restockText.classList.remove("has-oos");
  }
};

export default update;
